module.exports = __webpack_public_path__ + "static/media/faccia_04.9ee70084.png";